<template>
    <div class="pda-default">
        <router-view></router-view>

        <div class="mdc-card mdc-elevation--z3">
            <div v-for="(order, index) in listData" :key="index" @click="movePurchaseView(order.id)">
                <div class="pda-default">
                    <div class="t-helper t-color-gray2">
                        {{$t(order.category.translate)}}
                        <!-- 상품카테고리 -->
                    </div>
                    <div class="t-body2 mgt-2">
                        <!-- 디지털 미디어 애널리스트 : 소셜 네트워크 서비스 글로벌 마케팅 바로 알기 -->
                        {{order.goodsName}}
                    </div>
                    <div class="t-body4 mgt-8 d-flex flex-row justify-content-between align-items-center">
                        <div>
                            <span>
                                {{$t(order.status.translate)}}
                                 <!-- - {{order.status.value}} -->
                                <!-- 주문 상태 -->
                            </span>
                            <span class="mgr-8 mgl-8">
                                {{order.date ? $moment(order.date).format('L') : ''}}
                            </span>
                        </div>
                        <div>
                            {{order.refundCode}}
                        </div>
                        
                    </div>
                </div>
                <hr class="divider">
            </div>
        </div>

        <infinite-loading @infinite="fetchData" spinner="spiral">
            <div slot="no-more" class="pdt-16 pdb-16">No more data</div>
            <div slot="no-results" class="pdt-16 pdb-16"></div>
        </infinite-loading>
    </div>
</template>

<script>
/**
 * 멤버십 - 구매 목록 컴포넌트(membership - purchase list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import salesApi from '@/api/salesApi.js'
import NoData from '../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    components: {
        NoData, InfiniteLoading
    },

    data() {
        return {
            status: '',
            isNoData: false,
            listData: [],
            currentPage: 1,
            totalPages: 1
            
        }
    },
    
    updated() {
        const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
            let ripple = new MDCRipple.attachTo(el)
            return ripple
        })
    },

    methods: {

        // 목록 데이터 로딩(get list data)
        fetchData($state) {
            let responseData = null
            let params = this.setParams()

            if (this.totalPages >= this.currentPage) {
                salesApi.salesOrderList(params).then((response) => {
                    responseData = response.data.data
                    this.listData = this.listData.concat(responseData.content)

                    this.currentPage++
                    this.totalPages = responseData.totalPages
                    
                    if (responseData.content.length) {
                        $state.loaded()
                    }else {
                        $state.complete()
                    }

                    if (!this.listData.length) {
                        this.isNoData = true
                    }

                    this.$parent.setTopAppBarCustom({
                        leftBtnMode: 'arrow_back',
                        rightBtnMode: '',
                        title: this.$t('1020'), //'나의 구매 내역',
                        leftBtnMethod: () => {
                            this.$parent.moveParentRouter()
                        },
                        rightBtnMethod: '',
                    })
                })
            }else {
                $state.complete()
            }
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                page: this.currentPage,
                size: 10,
                // sort: 'id,desc'

            }
            return params
        },

        // move view
        movePurchaseView(id) {
            this.$router.push({
                name: 'MemberPurchaseView',
                params: {orderId: id}                
            })
        }
    }
}
</script>